import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import LeftArrow from './../PaginationControls/resources/arrow-left.svg';
import RightArrow from './../PaginationControls/resources/arrow-right.svg';
import './WStoreCategoriesNew.css';

const WStoreCategoriesNew = props => {
  const categoriesContainerRef = useRef(null);

  const scrollLeft = () => {
    categoriesContainerRef.current.scrollBy({
      left: -300,
      behavior: 'smooth'
    });
  };

  const scrollRight = () => {
    categoriesContainerRef.current.scrollBy({
      left: 300,
      behavior: 'smooth'
    });
  };

  const renderCategories = () => {
    const currCat =
      props.showDiscover && props.enableDiscover
        ? 'Discover'
        : props.currCategoryFilter.value;

    const wstoreCategories = props.categories.map((cat, index) => {
      const categoryName = cat.name === 'Quest' ? 'Quests' : cat.name;

      return (
        <div
          className={`category ${cat.value === currCat ? 'selected' : ''}`}
          key={index}
        >
          <button
            className="category-name"
            onClick={() => handleCategorySelection(props, cat)}
            type="button"
          >
            {categoryName}
          </button>
        </div>
      );
    });

    return wstoreCategories;
  };

  const handleCategorySelection = (props, category) => {
    if (category.value === 'All') {
      props.onSelectAllCategory();
    } else if (category.value === 'Hot Picks') {
      props.onSelectHotPicks();
    } else if (category.value === 'Discover') {
      props.onSelectDiscover();
    } else {
      props.onSelectCategory(category);
    }
  };

  return (
    <div className="wstore-categories-new">
      <button
        className="scroll-left-categories"
        onClick={scrollLeft}
        type="button"
      >
        <img src={LeftArrow} alt="Scroll Categories Left" />
      </button>
      <div
        id="categories-container"
        className="categories-container"
        ref={categoriesContainerRef}
      >
        {renderCategories(props)}
      </div>
      <button
        className="scroll-right-categories"
        onClick={scrollRight}
        type="button"
      >
        <img src={RightArrow} alt="Scroll Categories Right" />
      </button>
    </div>
  );
};

WStoreCategoriesNew.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  onSelectHotPicks: PropTypes.func.isRequired,
  onSelectAllCategory: PropTypes.func.isRequired,
  currCategoryFilter: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }),
  location: PropTypes.string
};

export default WStoreCategoriesNew;
